import { css } from "styled-components";

export const contentWidthStyle = css`
  max-width: 1085px;
  width: 80vw;
`;

export const contentWidthVw = "80vw";
export const contentWidthPx = "1085px";
export const projectGridGap = "22px";
export const ORANGE_DARK = "#E75D1A";
export const ORANGE_MEDIUM = "#F0783E";
export const ORANGE_MEDIUM_2 = "#FFA87D";
export const ORANGE_LIGHT = "#FFF1EB";
export const MOBILE_CUTOFF = "670px";
